var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.82812 22.2891H24.6641C25.1914 22.2891 25.6133 21.8789 25.6133 21.3516C25.6133 20.8125 25.1914 20.4023 24.6641 20.4023H9.82812C9.28906 20.4023 8.87891 20.8125 8.87891 21.3516C8.87891 21.8789 9.28906 22.2891 9.82812 22.2891Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16016 22.5117H5.16406C5.80859 22.5117 6.33594 21.9844 6.33594 21.3516C6.33594 20.6953 5.80859 20.1797 5.16406 20.1797H3.16016C2.51562 20.1797 2 20.6953 2 21.3516C2 21.9844 2.51562 22.5117 3.16016 22.5117Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82812 15.2109H24.6641C25.1914 15.2109 25.6133 14.7891 25.6133 14.2617C25.6133 13.7344 25.1914 13.3242 24.6641 13.3242H9.82812C9.28906 13.3242 8.87891 13.7344 8.87891 14.2617C8.87891 14.7891 9.28906 15.2109 9.82812 15.2109Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16016 15.4336H5.16406C5.80859 15.4336 6.33594 14.9063 6.33594 14.2617C6.33594 13.6172 5.80859 13.1016 5.16406 13.1016H3.16016C2.51562 13.1016 2 13.6172 2 14.2617C2 14.9063 2.51562 15.4336 3.16016 15.4336Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82812 8.12109H24.6641C25.1914 8.12109 25.6133 7.71094 25.6133 7.18359C25.6133 6.64453 25.1914 6.23438 24.6641 6.23438H9.82812C9.28906 6.23438 8.87891 6.64453 8.87891 7.18359C8.87891 7.71094 9.28906 8.12109 9.82812 8.12109Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16016 8.34375H5.16406C5.80859 8.34375 6.33594 7.81641 6.33594 7.18359C6.33594 6.52734 5.80859 6.01172 5.16406 6.01172H3.16016C2.51562 6.01172 2 6.52734 2 7.18359C2 7.81641 2.51562 8.34375 3.16016 8.34375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.723b9b38eeb10f4deff416e8295492bb.svg";
export { ForwardRef as ReactComponent };